import {FC, ReactNode, useState, MouseEvent} from 'react';
//mui
import {Box, Menu as MuiDropdown, MenuProps, SxProps, Theme} from '@mui/material';

interface ExtendedDropdownProps extends MenuProps {
	toggleContent: ReactNode;
	options: ReactNode;
	parentClassName?: SxProps<Theme>;
	open: boolean;
	onClose: () => void;
	onOpen: () => void;
	isCloseBackdrop?: boolean;
}

const Dropdown: FC<ExtendedDropdownProps> = ({
	toggleContent,
	options,
	open,
	onClose,
	onOpen,
	isCloseBackdrop,
	parentClassName,
	...rest
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
		onOpen();
	};

	const handleCloseClickBackdrop = () => {
		setAnchorEl(null);
		onClose();
	};

	const handleCloseClickItem = () => {
		if (!isCloseBackdrop) handleCloseClickBackdrop();
	};

	return (
		<Box sx={parentClassName}>
			<Box onClick={handleClick}>{toggleContent}</Box>

			<MuiDropdown {...rest} anchorEl={anchorEl} open={open} onClose={handleCloseClickBackdrop}>
				<Box onClick={handleCloseClickItem}>{options}</Box>
			</MuiDropdown>
		</Box>
	);
};

export default Dropdown;
